import React from "react";
import { firebaseFetchPage } from "../redux/firebase";
import { useQuery } from "@tanstack/react-query";
import useLanguage from "../redux/use-language";
import { LoadingContainer } from "../components/loading-container";

const Plans = () => {
  const { language } = useLanguage();
  const { data, isLoading, isFetching } = useQuery({
    queryKey: ["plans", language],
    queryFn: () => firebaseFetchPage("plans", language),
    staleTime: Infinity,
  });

  if (isLoading || isFetching) return <LoadingContainer />;
  if (!data) return <></>;
  return (
    <div className="sidebar-plans">
      <div className="sidebar-section-title">{language === "ru" ? "Планы" : "Plans"}</div>
      <div className="text-sm text-slate-600 leading-relaxed space-y-1">
        {data.map((entry, i) => (
          <div key={`plan-${i}`}>{entry}</div>
        ))}
      </div>
    </div>
  );
};

export default Plans;
